import { useContext } from 'react';
import { SliderValuesContext, AllInputDataContext } from '../../config';
import { Typography } from 'antd';
import { SizeIcon } from './SizeIcon';
import { valueToSize } from './MEControls';
import { playColors } from '../../constants';
const { Text } = Typography;

export const PlantSizeSummary = () => {
  const sliderValues = useContext(SliderValuesContext);
  const { technologyData } = useContext(AllInputDataContext);

  return (
    <div
      style={{
        width: '66%',
        padding: 6,
        display: 'flex',
        flexDirection: 'column',
        flexWrap: 'wrap',
        maxHeight: 130,
        maxWidth: '66%',
        minWidth: 'fit-content',
        gap: 2,
      }}
    >
      {technologyData.map((tech) =>
        tech.name !== 'Blackout' ? (
          <Text
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 4,
              color: playColors.black,
            }}
          >
            <SizeIcon
              size={valueToSize(sliderValues[tech.id - 1], tech.capMax)}
              color={playColors.black}
            />
            {tech.name}{' '}
          </Text>
        ) : null
      )}
    </div>
  );
};
